import { Component, OnInit, TemplateRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DatePipe } from '@angular/common';
import { forwardRef, Input, ViewChild } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDatepicker, MatDialog } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { SelectItem } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

const moment = _rollupMoment || _moment;

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-team-leave',
  templateUrl: './team-leave.component.html',
  styleUrls: ['./team-leave.component.scss'],
  animations: fuseAnimations,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TeamLeaveComponent),
      multi: true,
    },
  ],
})
export class TeamLeaveComponent implements OnInit {

  leaveDataColumns: string[] = ['months', 'noOfDays', 'details'];
  leaveResults = [];
  leaveResCount = 12;
  profileId = '';
  monthsOfTheYear = [
    { value: 0, month: 'January' },
    { value: 1, month: 'February' },
    { value: 2, month: 'March' },
    { value: 3, month: 'April' },
    { value: 4, month: 'May' },
    { value: 5, month: 'June' },
    { value: 6, month: 'July' },
    { value: 7, month: 'August' },
    { value: 8, month: 'September' },
    { value: 9, month: 'October' },
    { value: 10, month: 'November' },
    { value: 11, month: 'December' }
  ]
  nonWorkingDays = [];
  holidaysList = [];
  selectedLeaveDate = new Date();
  profileIds = [];
  allEmployeeLeaveResults = [];
  totalRecords = 0;
  currentEmployeeLeaveResults = [];
  searchValue = '';
  userName = '';
  userImage = '';
  selectedLeaveList = [];
  @ViewChild('deleteLeavePopup', { static: false }) deleteLeavePopup: TemplateRef<any>;
  selectedDate = new Date();
  selctedResource = '';
  holidayCount = 0;
  selectedHolidayYear = new Date();
  datePipe = new DatePipe('en-US');
  empRole = '';
  totalDays = '';
  totalHours = '';
  totalSickLeave = '';
  totalCasualLeave = '';
  departmentToDD = [];
  reportingToDD = [];
  selectedDepartment = '';
  selectedTeam = '';
  profileResults = [];
  monthlyData = [];
  sellectedMonthDate = new Date();
  selectedAbsentDate = new Date();
  dayCols = [
    { field: 'selection', header: '' },
    { field: 'position', header: 'Position' },
    { field: 'name', header: 'User Name' },
    { field: 'designation', header: 'Designation' },
    { field: 'department', header: 'Department' },
    { field: 'reportingTo', header: 'Reporting To' }
  ];
  absentCount = 0;
  roleDD = [];
  rollOptions: SelectItem[];

  _max: Moment;
  monthlyAbsentData = [];
  dayAbsentData = [];
  skipValue: number;
  tenantId: any;
  tenantRole: any;
  tenantDepartment: any;
  @Input()
  get max(): number | Date {
    return this._max ? this._max.year() : undefined;
  }
  set max(max: number | Date) {
    if (max) {
      const momentDate =
        typeof max === 'number' ? moment([max, 0, 1]) : moment(max);
      this._max = momentDate.isValid() ? momentDate : undefined;
    }
  }

  _min: Moment;
  @Input()
  get min(): number | Date {
    return this._min ? this._min.year() : undefined;
  }
  set min(min: number | Date) {
    if (min) {
      const momentDate =
        typeof min === 'number' ? moment([min, 0, 1]) : moment(min);
      this._min = momentDate.isValid() ? momentDate : undefined;
    }
  }

  touchUi = false;

  @ViewChild(MatDatepicker, { static: false }) _picker: MatDatepicker<Moment>;
  _inputCtrl: FormControl = new FormControl();
  _inputCtr2: FormControl = new FormControl();

  /** send the focus away from the input so it doesn't open again */
  _takeFocusAway = (datepicker: MatDatepicker<Moment>) => { };
  employeesList = '';
  selectedRows = [];
  tabIndex = 0;
  todayLeaveDetails = [];

  constructor(
    private parseService: ParseService,
    private hardCodedValues: HardCodedValues,
    private storageConfiguration: StorageConfiguration,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private dataService: DataService,
    private configuration: Configuration,
    private getReportingToService: GetReportingToService,
    private dateService: DateServiceService,
    private queryInterface: QueryInterface,
    private spinner: NgxSpinnerService
  ) {

  }

  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.getTenantDepartment();
    this.getTenantRole();
    this.profileId = this.parseService.instance.User.current().get('profile').id;

    const queryInstance = this.parseService.instance.Object.extend('CustomRoleSettings');
    const query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    let res = await query.find();
    let roleDetail = res[0];
    let customRoles = roleDetail.get('customRoles');
    let employeesdata = customRoles[0];
    var keys = Object.keys(employeesdata);
    var filtered = keys.filter(function (key) {
      if (typeof employeesdata[key] != 'string') {
        return employeesdata[key]
      }
    });
    this.employeesList = filtered[0];

    await this.getHolidays(new Date());
    this.getEmployeesList();
    await this.getProfileList();
    this.tabChange(0);
    this.getRollOption();
    this.getReportingTo();
    this.getDepartments();
  }

  async getHolidays(value) {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    let currentYear = new Date(value).getFullYear();
    holidayQuery.equalTo('year', currentYear);
    holidayQuery.equalTo('tenantId', this.tenantId);
    const leaveResults = await holidayQuery.find();
    if (leaveResults.length > 0) {
      let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
      for (let months in holidayList) {
        if (holidayList[months].length != 0) {
          let parsedMonths = parseInt(months);
          holidayList[months].forEach(element => {
            const officialLeaves = new Date(currentYear, parsedMonths, element);
            const epochLeaves = officialLeaves.getTime();
            this.nonWorkingDays.push(epochLeaves);
          });
        }
      }
    }
    let date = value;
    let year = date.getFullYear();
    let totalMonths = 12;
    for (let i = 0; i < totalMonths; i++) {
      let k = i + 1;
      let daysInMonth = new Date(year, k, 0).getDate();
      for (let j = 0; j < daysInMonth; j++) {
        let datesAll = new Date(year, i, j);
        let dayOfWeek = datesAll.getDay();
        let dateOfMonth = datesAll.getDate();
        let isEvenWeek = Math.ceil(dateOfMonth / 7);
        let epochOddDates = datesAll.getTime();
        if (dayOfWeek == 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
          if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
            this.nonWorkingDays.push(epochOddDates);
          }
        }
      }
    }
    let previousYear = year - 1;
    let daysInMonthLast = new Date(previousYear, 12, 0).getDate();
    for (let d = 1; d <= daysInMonthLast; d++) {
      let lastdatesAll = new Date(previousYear, 11, d);
      let lastdayOfWeek = lastdatesAll.getDay();
      let lastdateOfMonth = lastdatesAll.getDate();
      let lastisEvenWeek = Math.ceil(lastdateOfMonth / 7);
      let lastepochOddDates = lastdatesAll.getTime();
      if (lastdayOfWeek == 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      } if (lastdayOfWeek == 6 && lastisEvenWeek % 2 != 0) {
        if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
          this.nonWorkingDays.push(lastepochOddDates);
        }
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  async leaveYearSelectedHandler(chosenDate: Moment, datepicker: MatDatepicker<Moment>) {
    this.selectedDate = chosenDate.toDate();
    this.selectedLeaveDate = this.selectedDate;
    await this.getHolidays(this.selectedDate);
    this.getEmployeesList();
    datepicker.close();

    if (!this.isYearEnabled(chosenDate.year())) {
      return;
    }
    chosenDate.set({ date: 1 });
    this._inputCtrl.setValue(chosenDate, { emitEvent: false });
    this.onChange(chosenDate.toDate());
    this.onTouched();
  }

  openDatepickerOnClick(datepicker: MatDatepicker<Moment>) {
    if (!datepicker.opened) {
      datepicker.open();
    }
  }

  // Function to call when the date changes.
  onChange = (year: Date) => { };

  // Function to call when the input is touched (when a star is clicked).
  onTouched = () => { };

  /** Whether the given year is enabled. */
  isYearEnabled(year: number) {
    // disable if the year is greater than maxDate lower than minDate
    if (
      year === undefined ||
      year === null ||
      (this._max && year > this._max.year()) ||
      (this._min && year < this._min.year())
    ) {
      return false;
    }

    return true;
  }

  getDaysArray(start, end) {
    for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push((new Date(new Date(dt).getTime()).setHours(0, 0, 0, 0)));
    }
    return arr;
  };

  nextPage(event) {
    let pageNumber = event.pageIndex + 1;
    let value = pageNumber * 10;
    this.skipValue = value - 10;
    this.getEmployeesList();
  }

  async getEmployeesList() {
    let department = ''
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.ascending('firstName');
    query.include('reportingTo');
    query.include('location');
    query.include('department');
    query.include('role');
    query.equalTo('tenantId', this.tenantId);
    query.include('organisation');
    query.withCount();
    query.limit(10);
    if (this.skipValue != undefined) {
      query.skip(this.skipValue);
    }
    let value = this.searchValue.charAt(0).toUpperCase() + this.searchValue.slice(1);
    if (this.employeesList == 'Assigned') {
      query.equalTo('reportingTo', {
        __type: 'Pointer',
        className: 'Profile', objectId: this.profileId
      });
    }
    if (this.searchValue != '') {
      query.startsWith('firstName', value);
    }
    if (this.selectedDepartment != '' && this.selectedDepartment != 'all') {
      query.equalTo('department', {
        __type: 'Pointer',
        className: 'Department', objectId: this.selectedDepartment
      });
    }
    if (this.selectedTeam != '' && this.selectedTeam != 'all') {
      query.equalTo('reportingTo', {
        __type: 'Pointer',
        className: 'Profile', objectId: this.selectedTeam
      });
      // this.addCurrentTeamLead(this.selectedTeam);
    }
    let results = await query.find();
    let data = JSON.parse(JSON.stringify(results));
    this.totalRecords = data.count;
    this.profileIds = [];
    this.allEmployeeLeaveResults = [];
    for (const element of data.results) {

      this.profileIds.push(element.objectId);
      let image = '';
      var myObj = element.profileImageInfo;
      if (this.isEmpty(myObj)) {
        // Object is empty
        image = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        image = element.profileImageInfo.url
      }
      this.allEmployeeLeaveResults.push({
        profileId: element.objectId,
        name: element.firstName + ' ' + element.lastName,
        image: image,
        department: this.getReportingToService.getDepartmentDisplayName(element.department.name),
        // designation: element.role ? element.role.name : '',
        designation: this.getReportingToService.getRoleDisplayName(element.role.name),
        details: []
      });
    }
    this.getAllEmployeesLeaves();
  }

  async getAllEmployeesLeaves() {
    let date = new Date(this.selectedDate);
    let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
    let lastDate = (new Date(date.getFullYear(), 11, 31)).setHours(23, 59, 59, 999);
    let lastDayOfYear = new Date(lastDate);
    let leaveClass = this.parseService.instance.Object.extend('Leaves');
    let query = new this.parseService.instance.Query(leaveClass);
    query.greaterThan('startDate', firstDayOfYear);
    query.lessThan('startDate', lastDayOfYear);
    query.include('requesterId');
    query.containedIn('requesterId', this.profileIds);
    query.equalTo('tenantId', this.tenantId);
    query.limit(2000);
    let results = await query.find();
    for (const element of this.allEmployeeLeaveResults) {
      this.currentEmployeeLeaveResults = [];
      for (const res of this.monthsOfTheYear) {
        let noOfDays = 0;
        let noOfHours = 0;
        let details = [];
        this.currentEmployeeLeaveResults.push({
          position: res.value + 1,
          monthValue: res.value,
          months: res.month,
          noOfDays: noOfDays,
          noOfHours: noOfHours,
          noOfSickLeave: 0,
          noOfCasualLeave: 0,
          details: details
        });
      }
      let leaveData = results.filter(x => x.get('requesterId').id == element.profileId);
      let year = new Date(date).getFullYear();
      for (const element of this.monthsOfTheYear) {
        let firstDate = (new Date(year, element.value, 1)).setHours(0, 0, 0, 0);
        let lastDate = (new Date(year, element.value + 1, 0)).setHours(23, 59, 59, 999);
        let firstDay = new Date(firstDate);
        let lastDay = new Date(lastDate);
        let data = leaveData.filter((item) => {
          return item.get('startDate').getTime() >= firstDay
            && item.get('startDate').getTime() <= lastDay;
        });
        let details = [];
        for (const res of data) {
          let totalHours = 0;

          if ((res.get('requestType') != 'Permission') && (res.get('leaveType') != 'Half-Day-Leave')) {
            this.calculateTotalLeaves(res.get('startDate'), res.get('endDate'));
          }

          if (res.get('leaveType') == 'Sick-Leave') {
            this.calculateSickLeave(res.get('startDate'), res.get('endDate'));
          }

          if (res.get('leaveType') == 'Casual-Leave') {
            this.calculateCasualLeave(res.get('startDate'), res.get('endDate'));
          }

          if (res.get('leaveType') == 'Half-Day-Leave') {
            this.calculateHalfDayLeave(res.get('startDate'), res.get('endDate'));
          }

          if (res.get('requestType') == 'Permission') {
            let splitStartTime = (this.convertTime12to24(res.get('startTime'))).split(':');
            let splitEndTime = (this.convertTime12to24(res.get('endTime'))).split(':');
            let startTime = splitStartTime[0] + '.' + splitStartTime[1];
            let endTime = splitEndTime[0] + '.' + splitEndTime[1];
            totalHours = Number(endTime) - Number(startTime);
            this.hoursBetweenAllEmployees(totalHours, res.get('startDate'));
          }

          details.push({
            requestType: res.get('requestType'),
            status: res.get('status'),
            leaveType: res.get('leaveType'),
            startDate: res.get('startDate'),
            endDate: res.get('endDate'),
            startDateValue: this.datePipe.transform(new Date(res.get('startDate')), 'dd-MMM-yyyy'),
            endDateValue: this.datePipe.transform(new Date(res.get('endDate')), 'dd-MMM-yyyy'),
            totalDays: res.get('totalDays'),
            startTime: res.get('startTime'),
            endTime: res.get('endTime'),
            totalHours: totalHours
          });
        }
        let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == element.value);
        if (index != -1) {
          this.currentEmployeeLeaveResults[index].details = details;

        }
      }
      let indexValue = this.allEmployeeLeaveResults.findIndex(x => x.profileId == element.profileId);
      if (indexValue != -1) {
        this.allEmployeeLeaveResults[indexValue].details = this.currentEmployeeLeaveResults;
      }
    }
  }

  calculateTotalLeaves(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex(x => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      }
      else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == currentMonth);
        this.currentEmployeeLeaveResults[index].noOfDays += 1;
      }
    }
  }

  calculateHalfDayLeave(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let currentMonth = startDate.getMonth();
    let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == currentMonth);
    this.currentEmployeeLeaveResults[index].noOfDays += 0.5;
  }

  hoursBetweenAllEmployees(totalHours, startDate) {
    let currentMonth = new Date(startDate).getMonth();
    let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == currentMonth);
    this.currentEmployeeLeaveResults[index].noOfHours += totalHours;
  }

  calculateSickLeave(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex(x => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      }
      else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == currentMonth);
        this.currentEmployeeLeaveResults[index].noOfSickLeave += 1;
      }
    }
  }

  calculateCasualLeave(date1, date2) {
    let startDate = new Date(date1);
    let endDate = new Date(date2);
    let daylist = this.getDaysArray(new Date(startDate), new Date(endDate));
    for (var i = 0; i < daylist.length; i++) {
      let holiday = this.nonWorkingDays.findIndex(x => x === daylist[i]);
      if (holiday != -1) {
        daylist.splice(holiday, 1);
      }
      else {
        let currentMonth = new Date(daylist[i]).getMonth();
        let index = this.currentEmployeeLeaveResults.findIndex(x => x.monthValue == currentMonth);
        this.currentEmployeeLeaveResults[index].noOfCasualLeave += 1;
      }
    }
  }

  convertTime12to24(time12h) {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '12';
    }

    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
  }

  clearFilter() {
    this.searchValue = '';
    this.selectedDate = new Date();
    this.selectedDepartment = '';
    this.selectedTeam = '';
    this.getEmployeesList();
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  getSelectedLeave(profileId) {
    this.selctedResource = profileId;
    let indexValue = this.allEmployeeLeaveResults.findIndex(x => x.profileId == profileId);
    if (indexValue != -1) {
      let data = this.allEmployeeLeaveResults[indexValue];
      this.userName = data.name;
      this.userImage = data.image;
      this.selectedLeaveList = data.details;
      this.totalDays = this.selectedLeaveList.map(item => item.noOfDays).reduce((prev, next) => prev + next);
      this.totalHours = this.selectedLeaveList.map(item => item.noOfHours).reduce((prev, next) => prev + next);
      this.totalSickLeave = this.selectedLeaveList.map(item => item.noOfSickLeave).reduce((prev, next) => prev + next);
      this.totalCasualLeave = this.selectedLeaveList.map(item => item.noOfCasualLeave).reduce((prev, next) => prev + next);
    }
  }

  sendEmail() {
    let queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = this.selctedResource;
    let leaveData = JSON.parse(JSON.stringify(this.selectedLeaveList));
    let leaveDetails = [];
    let i = 0;
    for (const element of leaveData) {
      let leave = [];
      for (const res of element.details) {
        if (res.requestType != 'Permission') {
          leave.push(res);
        }
      }
      if (leave.length > 0) {
        leaveData[i].details = leave;
        leaveDetails.push(element);
      }
      i = i + 1;
    }

    let permissionData = JSON.parse(JSON.stringify(this.selectedLeaveList));
    let permissionDetails = [];
    let j = 0;
    for (const element of permissionData) {
      let permission = [];
      for (const res of element.details) {
        if (res.requestType == 'Permission') {
          permission.push(res);
        }
      }
      if (permission.length > 0) {
        permissionData[j].details = permission;
        permissionDetails.push(element);
      }
      j = j + 1;
    }
    let data = {
      userName: this.userName,
      userImage: this.userImage,
      leaveData: leaveDetails,
      permissionData: permissionDetails,
      toEmail: queryProfile.get('officialInfo').officialEmail,
      reporterEmail: queryProfile.get('reportingTo').get('officialInfo').officialEmail,
      totalDays: this.totalDays,
      totalHours: this.totalHours,
      totalSickLeave: this.totalSickLeave,
      totalCasualLeave: this.totalCasualLeave
    }
    this.dataService.add(this.configuration.leaveDetails, data).subscribe((data: any) => {
      if (data.message == 'Leave details sent successfully') {
        this.toastr.success('Mail sent successfully');
      }
      else {
        this.toastr.warning('Something went wrong');
      }
    });
  }

  async getDepartments() {
    this.departmentToDD = [];
    await this.getReportingToService.getDepartment().then(res => {
      this.departmentToDD = res;
    });
  }

  async getReportingTo() {
    this.reportingToDD = [];
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToDD = res;
    });
  }

  async addCurrentTeamLead(selectedTeam) {
    var queryProfile = new this.parseService.instance.Object('Profile');
    queryProfile.id = selectedTeam;
    let image = '';
    let dep = '';


    var myObj = queryProfile.get('profileImageInfo');
    if (this.isEmpty(myObj)) {
      // Object is empty
      image = this.hardCodedValues.defaultProfileImg;
    } else {
      // Object is NOT empty
      image = queryProfile.get('profileImageInfo').url
    }
    this.allEmployeeLeaveResults.push({
      profileId: this.selectedTeam,
      name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
      image: image,
      department: this.getReportingToService.getDepartmentDisplayName(queryProfile.get('department').get('name')),
      // designation: queryProfile.get('role') ? queryProfile.get('role').get('name') : '',
      designation: this.getReportingToService.getRoleDisplayName(queryProfile.get('role').get('name')),
      details: []
    });
  }

  async getProfileList() {
    this.profileResults = [];
    let dep = [];
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.ascending('firstName');
    query.include('reportingTo');
    query.include('location');
    query.include('department');
    query.include('role');
    query.include('organisation');
    query.withCount();
    query.limit(1000);
    query.include('role');
    query.equalTo('tenantId', this.tenantId);
    query.notEqualTo('department', { __type: 'Pointer', className: 'Department', objectId: '69jB8DdmHt' });
    let skipingUsers = ['y5RtBckAm2', 'BCAUtQsWO3', 'BVXvot0K5u'];
    query.notContainedIn('objectId', skipingUsers);
    let results = await query.find();
    let data = JSON.parse(JSON.stringify(results));
    for (const element of data.results) {

      this.profileIds.push(element.objectId);
      let image = '';
      var myObj = element.profileImageInfo;
      if (this.isEmpty(myObj)) {
        // Object is empty
        image = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        image = element.profileImageInfo.url
      }
      let reporterImage = '';
      var myObj = element.reportingTo.profileImageInfo;
      if (this.isEmpty(myObj)) {
        reporterImage = this.hardCodedValues.defaultProfileImg;
      } else {
        reporterImage = element.reportingTo.profileImageInfo.url
      }
      let value = new Date(this.selectedAbsentDate);
      let date = value.getDate() + '-' + (value.getMonth() + 1) + '-' + value.getFullYear()
      this.profileResults.push({
        profileId: element.objectId,
        name: element.firstName + ' ' + element.lastName,
        image: image,
        department: this.getReportingToService.getDepartmentDisplayName(element.department.name),
        // designation: element.role ? element.role.name : '',
        designation: this.getReportingToService.getRoleDisplayName(element.role.name),
        departmentId: element.department ? element.department.objectId : '',
        designationId: element.role ? element.role.objectId : '',
        reportingTo: element.reportingTo ? element.reportingTo.firstName + ' ' + element.reportingTo.lastName : '',
        reporterImage: reporterImage,
        reportingToId: element.reportingTo ? element.reportingTo.objectId : '',
        isSelected: false,
        email: element.officialInfo.officialEmail,
        date: date
      });
    }
  }

  async getCurrentMonthDates() {
    this.spinner.show();
    this.monthlyData = [];
    let date = new Date(this.sellectedMonthDate);
    let startend = this.startenddates(date);
    let firstDay = startend[0];
    let lastDay = startend[1];

    if (new Date() < lastDay) {
      let currentDate = new Date();
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - 1));
    }
    let datelist = await this.getDaysArray(firstDay, lastDay);
    let currentMonthDates = [];
    for (const value of datelist) {
      let holiday = this.nonWorkingDays.findIndex(x => x == value);
      if (holiday == -1) {
        currentMonthDates.push(value);
      }
    }
    if (currentMonthDates.length == 0) {
      currentMonthDates.push(new Date().setHours(0, 0, 0, 0));
    }
    let startDate = currentMonthDates[0];
    let lastValue = (currentMonthDates.slice(-1)[0]);
    let lastDate = (new Date(lastValue)).setHours(23, 59, 59, 999);
    let timesheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timesheet);
    query.descending('createdAt');
    query.greaterThan('createdAt', new Date(startDate));
    query.lessThan('createdAt', new Date(lastDate));
    query.limit(100000);
    query.include('profileId');
    query.equalTo('tenantId', this.tenantId);
    let userTimesheetResults = await query.find();
    this.spinner.hide();

    for (const element of currentMonthDates) {
      let date = new Date(element);
      let startend = this.dateService.startEndDateByDate(date);
      let results = userTimesheetResults.filter(x => x.get('createdAt') > startend[0] && x.get('createdAt') < startend[1]);
      this.monthlyAbsentData = JSON.parse(JSON.stringify(this.profileResults));
      for (const res of results) {
        if (res.get('profileId') != undefined) {
          let profileId = res.get('profileId').id
          let find = this.monthlyAbsentData.findIndex(x => x.profileId == profileId);
          this.monthlyAbsentData.splice(find, 1);
        }
      }
      this.monthlyData.push({
        date: this.datePipe.transform(new Date(element), 'dd-MMM-yyyy'),
        data: this.monthlyAbsentData,
        totalAbsentees: this.monthlyAbsentData.length
      });
    }
  }

  async getCurrentDayAbsent() {
    let timesheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timesheet);
    let date = new Date(this.selectedAbsentDate);
    let startend = this.dateService.startEndDateByDate(date);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.limit(100000);
    query.include('profileId');
    query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    this.dayAbsentData = JSON.parse(JSON.stringify(this.profileResults));
    for (const res of results) {
      if (res.get('profileId') != undefined) {
        let profileId = res.get('profileId').id
        let find = this.dayAbsentData.findIndex(x => x.profileId == profileId);
        if (find != -1) {
          this.dayAbsentData.splice(find, 1);
        }
      }
    }
    this.absentCount = this.dayAbsentData.length;
  }

  async tabChange(event) {
    if (event === 0) {
      this.tabIndex = 0;
      this.searchValue = '';
      this.selectedDate = new Date();
      this.selectedDepartment = '';
      this.selectedTeam = '';
      await this.getHolidays(new Date());
      this.getEmployeesList();
    }
    else if (event === 1) {
      this.tabIndex = 1;
      this.getCurrentDayAbsent();
      this.getTodayLeaveDetails();
    }
    else if (event === 2) {
      this.tabIndex = 2;
      this.getCurrentMonthDates();
    }
  }

  async getTodayLeaveDetails() {
    this.todayLeaveDetails = [];
    let leaves = this.parseService.instance.Object.extend('Leaves');
    let query = new this.parseService.instance.Query(leaves);
    let date = new Date(this.selectedAbsentDate);
    let startend = this.dateService.startEndDateByDate(date);
    query.greaterThan('startDate', startend[0]);
    query.lessThan('endDate', startend[1]);
    query.limit(100000);
    query.equalTo('tenantId', this.tenantId);
    query.include('requesterId');
    let results = await query.find();
    this.todayLeaveDetails = results;
  }

  selectChange(event) {
    this.dayAbsentData.forEach(element => {
      element.isSelected = false;
    });
    this.selectedRows.forEach(element => {
      element.isSelected = true;
    });
  }

  comparer(otherArray) {
    return function (current) {
      return otherArray.filter(function (other) {
        return other.get('requesterId').id == current.profileId
      }).length == 0;
    }
  }

  async sendLeave() {
    let selectedRows = this.selectedRows;
    let todayLeaveDetails = this.todayLeaveDetails;
    var notLeaveAppliedEmployees = selectedRows.filter(this.comparer(todayLeaveDetails));
    if (notLeaveAppliedEmployees.length > 0) {
      for (const element of notLeaveAppliedEmployees) {
        let leaveClass = this.parseService.instance.Object.extend('Leaves');
        let leave = new leaveClass();
        leave.set('startDate', new Date(this.selectedAbsentDate));
        leave.set('endDate', new Date(this.selectedAbsentDate));
        leave.set('startTime', '00:00');
        leave.set('endTime', '00:00');
        leave.set('sessionType', '');
        leave.set('totalDays', 1);
        leave.set('reason', 'Leave');
        var currentDate = this.selectedAbsentDate;
        currentDate.setDate(currentDate.getDate() + 1);
        leave.set('backToWorkDate', new Date());
        leave.set('appliedDate', new Date());
        leave.set('leaveType', 'Casual-Leave');
        leave.set('rejectReason', '');
        leave.set('status', 'Pending');
        leave.set('requestType', 'Post-Leave');
        leave.set('reporterId', { __type: 'Pointer', className: 'Profile', objectId: element.reportingToId });
        leave.set('requesterId', { __type: 'Pointer', className: 'Profile', objectId: element.profileId });
        leave.set('createdBy', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
        let data = await leave.save();
      }
      this.toastr.success('Leave applied successfully');
      this.getTodayLeaveDetails();

      this.dataService.add(this.configuration.sendLeave, notLeaveAppliedEmployees).subscribe((data: any) => {
        if (data.message == 'Leave mail sent successfully') {
          this.toastr.success('Mail sent successfully');
        }
        else {
          this.toastr.warning('Something went wrong');
        }
      });

    }
    else {
      this.toastr.warning('Already leave applied for these employees');
    }
  }

  getRollOption() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleInfo = JSON.parse(jsonText);
        if (roleInfo.displayName) {
          result.push({ id: roleInfo.role.objectId, name: roleInfo.displayName });
          this.roleDD = result;
        }
        else {
          result.push({ id: roleInfo.objectId, name: roleInfo.name });
          this.roleDD = result;
        }
      }
      this.rollOptions = this.bindDropDown(this.roleDD);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  async monthSelector(event) {
    this.sellectedMonthDate = event;
    await this.getHolidays(event);
    this.getCurrentMonthDates();
  }

  daySelector(event): void {
    this.selectedAbsentDate = event;
    let selectedDate = new Date(event).setHours(0, 0, 0, 0);
    let isHoliday = this.nonWorkingDays.filter(x => x == selectedDate);
    if (isHoliday.length == 0) {
      this.getCurrentDayAbsent();
      this.getTodayLeaveDetails();
      this.selectedRows = [];
      for (const element of this.profileResults) {
        let value = new Date(this.selectedAbsentDate);
        let date = value.getDate() + '-' + (value.getMonth() + 1) + '-' + value.getFullYear();
        element.date = date;
      }
    }
    else {
      this.dayAbsentData = [];
      this.absentCount = this.dayAbsentData.length;
    }
  }

  startenddates(day) {
    let getTot = this.daysInMonth(day.getMonth(), day.getFullYear(), day.getDate());
    let as = Math.round(getTot / 2);
    day.setDate(as);
    let startdate = this.daybefore(new Date(day));

    let enddate = this.dayafter(day);
    return [startdate, enddate];
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 0);
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 1);
  }

  daysInMonth(month, year, date) {
    return new Date(year, month, date).getDate();
  }

  async getTenantRole(): Promise<void> {
    this.tenantRole = await this.getReportingToService.getTenantRole(this.tenantId);
  }

  async getTenantDepartment(): Promise<void> {
    this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

  handleMissingImage(event) {
    this.userImage = '../../../../../assets/images/avatars/profile.jpg';
  }

}
